import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridData, RegistrationState } from '../../definitions';
import { RegistrationService } from '../../registration.service';
import { KngButtonState, KngGridPager, ModalComponent, ModalEvent, ModalState } from 'kinetic-angular';
import { ButtonState, ErrorMessageHeading, ErrorMessageSubHeading, KngUploadFileComponent, PagerService } from 'projects/kinetic-angular/src/lib/components';
import { RegistrationUtilService } from '../../registration-util.service';
import { CssClass, ModalButtonId } from '../../../../services/shared/shared-enums';
import { SharedUtilService } from '../../../../services/shared/shared-util.service';
import { AnalyticsService } from 'projects/tmhna-portal/src/app/services/analytics/analytics.service';
import { AnalyticsDataLayer } from 'projects/tmhna-portal/src/app/services/analytics/definitions';

@Component({
	selector: 'tmhna-portal-registration-additional-locations',
	templateUrl: './registration-additional-locations.component.html',
	styleUrls: ['./registration-additional-locations.component.scss']
})
export class RegistrationAdditionalLocationsComponent implements OnInit
{
	allSelected: boolean = false;
	selectedGridData: GridData[] = [];
	pageNumber: number = 1;
	currentPage: number = 1;
	pager: KngGridPager = {
		totalPages: 1,
		currentPage: this.currentPage,
		endIndex: 0,
		endPage: 1,
		pageSize: 50,
		startIndex: 0,
		startPage: 1,
		totalItems: this.state.additionalLocationGrid.length
	};
	errorMessage:string = 'This domain is already taken! Need assistance?';
	contactUs = {
		label: 'Contact Us',
		url: '/contact-us'
	};
	claimDomain: boolean = false;
	@ViewChild('confirmSubmit') confirmSubmit!: ModalComponent;
	@ViewChild('uploadModal') uploadModal!: ModalComponent;
	@ViewChild(KngUploadFileComponent, { static: false }) fileUploadComponent: | KngUploadFileComponent | undefined;
	@Input() set state(value: RegistrationState)
	{
		this.service.updateState(value);
	}
	get state(): RegistrationState
	{
		return this.service.state;
	}
	get businessRegistrationFlowSubmitModalState(): ModalState
	{
		return this.service.businessRegistrationFlowSubmitModalState;
	}
	get businessRegistrationUploadListModalState(): ModalState
	{
		return this.service.businessRegistrationUploadListModalState;
	}
	get downloadButtonState(): KngButtonState 
	{
		return this.service.downloadButtonState;
	}

	get userDomain(): string
	{
		if(this.state.email)
		{
			return this.state.email.split('@')[1];
		}
		return '';
	}
	constructor(public service: RegistrationService, public pagerService: PagerService, private readonly registrationUtilService: RegistrationUtilService, private readonly sharedUtilService: SharedUtilService,
		private readonly analyticsService: AnalyticsService) {}

	ngOnInit()
	{
		this.service.verifyDomainClaimed(this.userDomain);
		this.service.getAdditionalLocationList();
		this.service.getBusinessRegistrationFlowSubmitModalLabels();
		this.service.getBusinessRegistrationUploadListModalLabels();
		this.setPage(1);
		const analyticsData: AnalyticsDataLayer = {
			event: 'pageView',
			page: {
				name: 'Complete your Profile'
			}
		};
		this.analyticsService.trackRegistrationByEvent(analyticsData, this.state.email);
	}

	setAll(completed: boolean) 
	{
		this.service.checkAll = completed;
		this.allSelected = completed;
		this.state.additionalLocationGrid.forEach(t => (t.checked = completed));
		if(completed)
			this.selectedGridData = [...this.state.additionalLocationGrid];
		else
			this.selectedGridData = [];
	}

	countOfSelectedRequests() 
	{
		const countOfSelectedRequests = this.selectedGridData.length;
		return countOfSelectedRequests;
	}
	cancelSelection() 
	{
		this.state.additionalLocationGrid.forEach((row) => { row.checked = false; });
		this.allSelected = false;
		this.service.checkAll = false;
		this.selectedGridData = [];
	}
	partiallySelected(): boolean 
	{
		return this.state.additionalLocationGrid.filter(t => t.checked).length > 0 && !this.allSelected;
	}
	updateAllSelected() 
	{
		this.selectedGridData = [];
		this.allSelected = this.state.additionalLocationGrid.every(row => row.checked);
		if(this.allSelected)
		{
			this.service.checkAll = true;
		}
		this.state.additionalLocationGrid.forEach(ele =>
		{
			if(ele.checked)
				this.selectedGridData.push(ele);
		});
	}
	setPage(e: number) 
	{
		this.pager.totalPages = Math.ceil(this.state.additionalLocationGrid.length / 50);
		this.pageNumber = e;
		if (e < 1 || e > this.pager.totalPages) 
		{
			return;
		}
		else 
		{
			this.pager.currentPage = e;
		}

		this.currentPage = e;
		this.pager = this.pagerService.getPager(this.state.additionalLocationGrid.length, e, 50);
	}
	submitAdditionalLocation(proceedWithoutLocation: boolean = false)
	{
		if(this.isLocationSelected(proceedWithoutLocation))
		{
			const selectedLocationGrids:string[] = this.registrationUtilService.getLocationsByGrids(this.selectedGridData);
			this.service.submitAdditionalLocation(selectedLocationGrids, this.claimDomain);
			return;
		}
		if(this.service.isUploadSuccess)
		{
			this.service.submitAdditionalLocation([], this.claimDomain);
			return;
		}
		this.openModalLocationNotSelected();
	}
	isLocationSelected(proceedWithoutLocation: boolean)
	{
		return (this.state.additionalLocationGrid.length === 0 || (this.state.additionalLocationGrid.length > 0 && this.selectedGridData.length > 0)) || proceedWithoutLocation;
	}
	openModalLocationNotSelected()
	{
		this.businessRegistrationFlowSubmitModalState.hidden = false;
		this.businessRegistrationFlowSubmitModalState.label = this.state.businessRegistrationFlowSubmitModalLabels.heading;
	}
	confirmRemovalModalEvent(event: ModalEvent)
	{
		if(event.cta.id === ModalButtonId.cancel)
		{
			this.businessRegistrationFlowSubmitModalState.hidden = false;
			this.confirmSubmit.closePopup();
			this.businessRegistrationFlowSubmitModalState.hidden = true;
		}
		if (event.cta.id === ModalButtonId.proceed)
		{
			this.confirmSubmit.closePopup();
			this.businessRegistrationFlowSubmitModalState.hidden = true;
			this.sharedUtilService.hideModalBackdrop();
			this.submitAdditionalLocation(true);
		}
	}
	uploadListLocation()
	{
		this.openUploadModal();
	}
	openUploadModal()
	{
		this.state.uploadFileSection.download.errorMessage='';
		this.service.downloadTemplateError = false;
		this.state.additionalLocationGrid.forEach(t => (t.checked = false));
		this.allSelected = false;
		this.service.checkAll = false;
		this.selectedGridData = [];
		this.businessRegistrationUploadListModalState.hidden = false;
		this.businessRegistrationUploadListModalState.label = this.state.uploadFileSection.heading;
		this.businessRegistrationUploadListModalState.buttons[0].label=this.state.uploadFileSection.cancel;
		this.businessRegistrationUploadListModalState.buttons[1].label=this.state.uploadFileSection.upload;
		this.businessRegistrationUploadListModalState.buttons[2].hidden = true;
		this.businessRegistrationUploadListModalState.buttons[1].disabled = true;
		this.analyticsService.trackRegistrationByEvent({
    		event: 'Upload Locations',
    		link: {
    			name: 'Upload Locations'
    		}
    	}, this.state.email);
	}
	closeModalUpload(event? : ModalEvent)
	{
		this.service.resetFileStateModel();
		this.businessRegistrationUploadListModalState.buttons[0].disabled = false;
		this.businessRegistrationUploadListModalState.buttons[0].hidden = false;
		this.businessRegistrationUploadListModalState.buttons[1].hidden = false;
		this.businessRegistrationUploadListModalState.buttons[1].disabled = true;
		this.businessRegistrationUploadListModalState.buttons[0].label = this.state.uploadFileSection.cancel;
		this.businessRegistrationUploadListModalState.buttons[0].cssClass = CssClass.btnSecondary;
		this.businessRegistrationUploadListModalState.hidden = true;
		if(this.fileUploadComponent)
			this.fileUploadComponent.files = [];
		if(event?.cta.id !== ModalButtonId.close)
		{
			this.analyticsService.trackRegistrationByEvent({
				event: 'Upload Cancel',
				link: {
					name: 'Upload Cancel'
				}
			}, this.state.email);
		}
		this.sharedUtilService.hideModalBackdrop();	
	}
	confirmUserListModalEvent(event: ModalEvent)
	{
		const btnIndex = event.state.buttons.findIndex((cta: ButtonState) => cta.label === event.cta.label);
		if (btnIndex === 1)
		{
			if(this.fileUploadComponent)
				this.uploadFileServerValidation(this.fileUploadComponent.files[0]);
		}
		else
		{
			this.businessRegistrationUploadListModalState.hidden = false;
			this.businessRegistrationUploadListModalState.hidden = true;
			this.closeModalUpload(event);
			this.sharedUtilService.hideModalBackdrop();
		}
	}
	downloadLocationTemplate()
	{
		this.service.getBusinessRegistrationLocationDownload();
	}
	uploadFileServerValidation(item: File)
	{
		this.service.checkServerValidationUploadFile(item);
	}
	replaceFileEventEmitter()
	{
		this.businessRegistrationUploadListModalState.buttons[0].disabled = false;
		this.businessRegistrationUploadListModalState.buttons[1].hidden = false;
		this.businessRegistrationUploadListModalState.buttons[1].disabled = true;
		if(this.fileUploadComponent)
			this.fileUploadComponent.files = [];
	}
	fileValidationCheck(item: File)
	{
		const fileNameArr = item.name.split('.');
    	fileNameArr.pop();
    	const fileName = fileNameArr.join('.');
		if(fileNameArr.length !== 1 || fileName.trim().length === 0 || fileName.includes('/') || /\\/.exec(fileName) || item.name.split('.').pop()!=='xlsx') 
		{
			this.service.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.service.uploadFileState.errorSubHeading = ErrorMessageSubHeading.wrongFormat;
			this.emptyUploadFilesArray();
			this.analyticsService.trackRegistrationByEvent({
				event: 'Upload Error',
				error: {
					message: ErrorMessageSubHeading.wrongFormat
				}
			}, this.state.email);
		}
		else
		{
			this.checkOtherFileValidation(item);
		}
	}
	checkOtherFileValidation(item: File)
	{
		const fileSize = Math.round((item.size / 1024));
		if(fileSize > 102400 || fileSize < 9.58) 
		{
			this.service.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.service.uploadFileState.errorSubHeading = ErrorMessageSubHeading.incorrectSize;
			this.emptyUploadFilesArray();
			this.analyticsService.trackRegistrationByEvent({
				event: 'Upload Error',
				error: {
					message: ErrorMessageSubHeading.incorrectSize
				}
			}, this.state.email);
		}
		else 
		{
			if(this.fileUploadComponent)
				this.fileUploadComponent.files[0] = item;
			this.businessRegistrationUploadListModalState.buttons[1].disabled = false;
			this.businessRegistrationUploadListModalState.buttons[1].hidden = false;
			this.service.uploadFileState.isSuccessClient = true;
			this.service.uploadFileState.isSuccessServer = false;
		}
	}
	emptyUploadFilesArray()
	{
		this.businessRegistrationUploadListModalState.buttons[1].hidden = true;
		this.service.uploadFileState.isError = true;
		this.service.uploadFileState.isSuccessClient = false;
		this.service.uploadFileState.isSuccessServer = false;
		if(this.fileUploadComponent)
			this.fileUploadComponent.files = [];
	}
	
}
